export { ReactComponent as IconAnnotationAccepted } from './thumbs_up.svg';
export { ReactComponent as IconAnnotationRejected } from './thumbs_down.svg';
export { ReactComponent as IconAnnotationSubmitted } from './entity_created.svg';
export { ReactComponent as IconDraftCreated } from './draft_created.svg';
export { ReactComponent as IconDraftCreated2 } from './draft_created2.svg';
export { ReactComponent as IconAnnotationPrediction } from './prediction.svg';
export { ReactComponent as IconAnnotationSkipped } from './skipped.svg';
export { ReactComponent as IconAnnotationImported } from './imported.svg';
export { ReactComponent as IconAnnotationReviewRemoved } from './removed.svg';
export { ReactComponent as IconAnnotationPropagated } from './propagated.svg';
export { ReactComponent as IconAnnotationGroundTruth } from './ground_truth.svg';
export { ReactComponent as IconAnnotationSkipped2 } from './skipped2.svg';
